export const sanitizePhone = (phone: string) => {
	// remove non numerical chars
	return phone ? Number(String(phone).replace(/\D/g, '')) : null;
};
